import ActiveJourneyPill from 'components/elements/active-journey-pill';
import ActiveJourneysModal from './active-journeys-modal';
import { useOpenClose } from '@evertrue/et-components';
import { PropTypes } from 'base/react-libs';

const ActiveJourneysPills = ({ activeJourneys = [], activeV2Cadences = [], contactName }) => {
  const [isModalOpen, openModal, closeModal] = useOpenClose();

  const totalCount = activeJourneys.length + activeV2Cadences.length;
  // Show one inline pill per cadence version when both exist; otherwise show the first
  // available pill from whichever side has data.
  const inlineCount = (activeJourneys.length > 0 ? 1 : 0) + (activeV2Cadences.length > 0 ? 1 : 0);
  const overflow = totalCount - inlineCount;

  return (
    <>
      <div style={{ display: 'flex' }}>
        {activeJourneys.length > 0 && (
          <ActiveJourneyPill activeCadence={activeJourneys[0]} type={'profile'} contactName={contactName} />
        )}
        {activeV2Cadences.length > 0 && (
          <ActiveJourneyPill activeCadence={activeV2Cadences[0]} type={'profile'} contactName={contactName} />
        )}
        {overflow > 0 && (
          <div className="profile-header--cadence" onClick={openModal}>
            <p>+ {overflow} more</p>
          </div>
        )}
      </div>
      <ActiveJourneysModal
        isOpen={isModalOpen}
        closeModal={closeModal}
        activeJourneys={activeJourneys}
        activeV2Cadences={activeV2Cadences}
        contactName={contactName}
      />
    </>
  );
};

ActiveJourneysPills.propTypes = {
  activeJourneys: PropTypes.array,
  activeV2Cadences: PropTypes.array,
  contactName: PropTypes.string,
};

export default ActiveJourneysPills;
